import { onboardingClient, operatorClient } from 'domain/HttpClients';
import { getUserFromLocalStorage } from 'domain/fuse/auth/utils';

export const getTruckTypes = (token = getUserFromLocalStorage()?.tokens?.idToken) =>
  onboardingClient
    .Get('/api/vehicles/defaults')
    .withHeaders({
      Authorization: `Bearer ${token}`,
      'Content-type': 'application/json',
    })
    .withParams({ domain: SYSTEM_DOMAIN })
    .send();

export const getAccountsTokens = async (requestType = false) => {
  try {
    const response = await operatorClient
      .Get('/api/accounts/list-tokens')
      .withParams({
        accountTypes: requestType ? 'COURIER,PRIMARY_COURIER' : null,
      })
      .send();

    return response.map((item) => ({
      label: item.token,
      value: item.token,
      id: item.accountId,
      subLabel: item.accountName,
    }));
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getDriverProfileId = async (refId) => {
  try {
    const response = await operatorClient
      .Get('/api/drivers')
      .withParams({ refId: refId })
      .send();
    console.log({ response });
    return response.results[0].id;
  } catch (e) {
    console.error(e);
    return null;
  }
};
